import React from 'react';
import { Alert } from '@mui/material';
import { IPassengerDetail } from 'features/passengers/types';
import { formatAmount } from '../../uiHelpers';
import { useSaleOrderInvoicing } from './InvoicingContext';

/**
 * Banner rojo en el home de la orden cuando algún cliente facturable supera su
 * límite de crédito. El criterio unificado es el SALDO GENERAL DE COBRO del
 * cliente (venta − cobrado en todas sus órdenes, esté facturado o no), que es
 * la exposición real — no el saldo de facturas.
 * El caller gatea por segmento (no aplica a Leisure).
 */

export const clientDisplayName = (client: IPassengerDetail): string =>
	client.isPhysicalPerson ? `${client.name} ${client.lastName}`.trim() : client.name;

export const isOverCreditLimit = (client: IPassengerDetail): boolean =>
	client.maximumCreditAmount != null && (client.pendingPayAmount ?? 0) > client.maximumCreditAmount;

export const CreditLimitBanner = (): JSX.Element | null => {
	const { invoiceableClients } = useSaleOrderInvoicing();

	const overLimit = invoiceableClients.filter(isOverCreditLimit);
	if (overLimit.length === 0) return null;

	return (
		<>
			{overLimit.map((client) => (
				<Alert key={client.keyId} severity="error" variant="filled" sx={{ mb: 2 }}>
					🚨 {clientDisplayName(client)} supera su límite de crédito: saldo pendiente{' '}
					{formatAmount(client.pendingPayAmount ?? 0, 'USD')} / tope{' '}
					{formatAmount(client.maximumCreditAmount ?? 0, 'USD')} (todas sus órdenes, cobros pendientes).
				</Alert>
			))}
		</>
	);
};

export default CreditLimitBanner;
